<template>
  <v-container>
    <v-sheet>
      <v-img src="/safesytelogo-tagline.png" width="60%" class="mx-auto"></v-img>
    </v-sheet>

    <v-row>
      <v-col>
        Neem contact op voor meer informatie of maak een afspraak voor een vrijblijvend gesprek.
        <br />
        <br />
        <v-card>
          <v-card-title>Contactgegevens</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-if="false">
                <v-list-item-icon>
                  <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <a href="tel:info@safesyte.nl">012 345 6789</a>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-at</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <a href="mailto:info@safesyte.nl">info@safesyte.nl</a>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-web</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <a href="https://safesyte.nl">safesyte.nl</a>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>